var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExcorpLogoColor01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 155.9 155.9",
    style: {
      enableBackground: "new 0 0 155.9 155.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5CFF8A;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114,92.2H48.3c-0.9,0-1.6,0.7-1.6,1.6c0,0,0,0,0,0v25.3c0,0.9,0.7,1.6,1.6,1.6h27.5c0.6,0,1.1,0.5,1.1,1.1 c0,0.3-0.1,0.5-0.3,0.7l-25.1,25.2c-0.7,0.7-1.7,1.1-2.7,1.1H9.1c-1.1,0-2-0.9-2-2v-24c0-1,0.4-2,1.1-2.7l40.5-40.7 c0.8-0.8,0.8-2,0.1-2.8c0,0,0,0-0.1-0.1L8.2,36c-0.7-0.7-1.1-1.7-1.1-2.7V9.1c0-1.1,0.9-2,2-2l0,0h39.4c1,0,2,0.4,2.7,1.1l25.5,25.5 c0.4,0.4,0.4,1.1,0,1.5c-0.2,0.2-0.5,0.3-0.7,0.3H48.3c-0.9,0-1.6,0.7-1.6,1.6c0,0,0,0,0,0v24.3c0,0.9,0.7,1.6,1.6,1.6c0,0,0,0,0,0 H114c1.3,0,2.3,1,2.3,2.3c0,0,0,0,0,0v24.5C116.3,91.1,115.3,92.2,114,92.2L114,92.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M148.8,146.7v-23.9c0-1.1-0.9-2-2-2H95.4c-0.6,0-1.1,0.5-1.1,1c0,0.3,0.1,0.6,0.3,0.8l25.2,25.2 c0.7,0.7,1.7,1.1,2.7,1.1h24.1C147.9,148.9,148.8,147.9,148.8,146.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.8,7.1h-24.4c-1,0-2,0.4-2.7,1.1L94.3,33.7c-0.4,0.4-0.4,1.1,0,1.5c0.2,0.2,0.5,0.3,0.7,0.3h51.7 c1.2,0,2.1-0.9,2.1-2.1V9.1C148.8,8,147.9,7.1,146.8,7.1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcorpLogoColor01);
export default __webpack_public_path__ + "static/media/EXCORP_logo_color-01.fdd976a69f61902d563bc2e70f98222d.svg";
export { ForwardRef as ReactComponent };